import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'Pack de Scripts WhatsApp',
  subtitle: 'Bono 1',
  desc: 'Mensajes listos para responder consultas, enviar condiciones, cerrar reservas y comunicarte con más claridad.',
  image: 'https://cdn.magicpatterns.com/uploads/5xGp6Tm4aKFXdQhe98iHEF/bono_1.png',
  value: '$4.990'
}, {
  title: 'Fichero Técnico de Clientas',
  subtitle: 'Bono 2',
  desc: 'Una herramienta para registrar información clave, seguimiento y detalles importantes de cada servicio.',
  image: 'https://cdn.magicpatterns.com/uploads/wuLM6mUzaPGSs4gpViXk2X/bono_2.png',
  value: '$5.990'
}, {
  title: 'Checklist Operativo Diario',
  subtitle: 'Bono 3',
  desc: 'Tu guía práctica para mantener orden antes, durante y después de cada jornada.',
  image: 'https://cdn.magicpatterns.com/uploads/ku7iWDjMK3CcidYsAgfLyN/bono_3.png',
  value: '$3.990'
}, {
  title: 'Kit de Políticas Profesionales',
  subtitle: 'Bono 4',
  desc: 'Textos y estructura para comunicar señas, cancelaciones, horarios, llegadas tarde y condiciones del servicio.',
  image: 'https://cdn.magicpatterns.com/uploads/hhP2JGe8SoPefrrcj1UCRK/bono_4.png',
  value: '$5.990'
}, {
  title: 'Planner Semanal de Control del Negocio',
  subtitle: 'Bono 5',
  desc: 'Una vista simple para organizar tareas, turnos, prioridades y seguimiento semanal.',
  image: 'https://cdn.magicpatterns.com/uploads/5nJrusPk46VL3sLsstjQub/bono_5.png',
  value: '$4.990'
}, {
  title: 'Pack de Hojas Manuales para Costos y Precios',
  subtitle: 'Bono 6',
  desc: 'Plantillas para ayudarte a calcular mejor y dejar de tomar decisiones a ojo.',
  image: 'https://cdn.magicpatterns.com/uploads/7FmNHPiv2nrNjN9uvm9FsM/bono_6.png',
  value: '$4.990'
}];
export function Bonuses() {
  return <section className="py-20 bg-white" data-id="element-11">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-14">
            Más los 6 Bonos Estratégicos
          </h2>
          <p className="text-lg text-gray-600" data-id="element-15">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-16" data-id="element-16">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-ocean-cream rounded-3xl border border-gray-100 shadow-sm overflow-hidden flex flex-col" data-id="element-17">
              {bonus.image ? <div className="w-full aspect-square overflow-hidden" data-id="element-18">
                  <img src={bonus.image} alt={`${bonus.subtitle} - ${bonus.title}`} className="w-full h-full object-cover" data-id="element-19" />
                </div> : <div className="w-full aspect-square bg-white border border-dashed border-gray-200 flex items-center justify-center" data-id="element-20">
                  <Gift className="w-12 h-12 text-gray-300" data-id="element-21" />
                </div>}
              <div className="p-6 flex-1 flex flex-col" data-id="element-22">
                <div className="flex items-center justify-between mb-2" data-id="element-23">
                  <div className="text-sm font-bold uppercase tracking-wider text-ocean-teal" data-id="element-24">
                    {bonus.subtitle}
                  </div>
                  <div className="flex items-center gap-2" data-id="element-25">
                    <span className="text-sm text-gray-400 line-through" data-id="element-26">
                      {bonus.value}
                    </span>
                    <span className="bg-ocean-gold text-white text-xs font-bold px-2 py-1 rounded" data-id="element-27">
                      GRATIS
                    </span>
                  </div>
                </div>
                <h3 className="text-xl font-bold mb-2 text-gray-900" data-id="element-28">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-29">
                  {bonus.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="max-w-2xl mx-auto bg-ocean-teal-light rounded-2xl p-8 text-center border border-ocean-teal/20" data-id="element-30">
          <p className="text-gray-600 mb-2" data-id="element-31">Valor total de los 6 Bonos</p>
          <div className="flex items-center justify-center gap-3 text-2xl md:text-3xl font-bold" data-id="element-32">
            <span className="text-gray-400 line-through" data-id="element-33">$30.940</span>
            <span className="text-ocean-teal-dark" data-id="element-34">🎁 GRATIS</span>
          </div>
          <p className="text-sm text-ocean-teal mt-2 font-medium" data-id="element-35">
            — Solo en este lanzamiento —
          </p>
        </div>
      </div>
    </section>;
}